import { useEffect, useState } from "react";
import { http } from "@/lib/api";
import { Card, PageTitle } from "@/components/portal/ui";
import { money } from "@/lib/constants";

const NAMES = { diagnostic: "Infant Sleep Diagnostic", blueprint: "Personalized Blueprint",
  guided: "Guided Virtual Consulting", inhome_overnight: "In-Home + Overnight" };

export default function Purchases() {
  const [items, setItems] = useState([]);
  useEffect(() => { http.get("/portal/overview").then((r) => setItems(r.data.purchases)).catch(() => {}); }, []);
  const total = items.reduce((s, p) => s + (p.amount || 0), 0);

  return (
    <div>
      <PageTitle eyebrow="Purchases" title="Your purchases" sub="Every purchase stays attached to your one account and history." />
      <Card className="p-2">
        {items.length === 0 ? <p className="text-[#6B665E] text-sm p-5">No purchases yet.</p> : (
          <table className="w-full text-sm">
            <thead><tr className="text-[#8A998C] text-xs uppercase tracking-wide"><th className="text-left p-4">Product</th><th className="text-left p-4">Date</th><th className="text-right p-4">Amount</th></tr></thead>
            <tbody>
              {items.map((p) => (
                <tr key={p.id} className="border-t border-[#F0ECE4]">
                  <td className="p-4 text-[#1A1918]">{NAMES[p.product_key] || p.product_key}</td>
                  <td className="p-4 text-[#6B665E]">{new Date(p.created_at).toLocaleDateString()}</td>
                  <td className="p-4 text-right text-[#1A1918]">{money(p.amount)}</td>
                </tr>
              ))}
              <tr className="border-t border-[#E5E1D8] font-medium">
                <td className="p-4 text-[#1A1918]" colSpan={2}>Lifetime total</td>
                <td className="p-4 text-right text-[#1A1918]">{money(total)}</td>
              </tr>
            </tbody>
          </table>
        )}
      </Card>
      <p className="text-xs text-[#8A998C] mt-4">Each product is standalone — no discounted upgrades and no credits between products.</p>
    </div>
  );
}
